module.exports = __webpack_public_path__ + "img/20180815_152858_233.5e2a2661.jpg";